import { isDate, isDateTime, isEnum, isFile, isMultienum } from 'customer-data-objects/property/PropertyIdentifier';
export const getPropertyAutosaveEvent = property => {
  // https://git.hubteam.com/HubSpot/foundations-components/issues/2473
  // Blur / focus is broken for multi-enum with UISelect anchorType="button"
  // so we want to autosave on close, not on blur
  // We generally want to support saving on close for any field with a select menu
  // because some menus will still be focused after selecting an option.
  return isMultienum(property) || isEnum(property) || isDate(property) || isDateTime(property) || isFile(property) ? 'close' : 'blur';
};